import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import { SelectBox, NumberBox } from 'devextreme-react';
import { TagBox } from 'devextreme-react/tag-box';
import { Button } from 'devextreme-react/button';
import apiRoutes from "../../assets/apiRoutes.json";
import notify from 'devextreme/ui/notify';
import { LoadPanel } from 'devextreme-react/load-panel';
import ScrollView from 'devextreme-react/scroll-view';
import ungroupedRoutesData from "../../const/RoutesList";
import DataSource from "devextreme/data/data_source";
import { OM, WM, SO, IM, SettingModules } from "../../const/constants";
import { Drawer } from "devextreme-react/drawer";
import { List } from "devextreme-react/list";
import { Switch, TextBox } from "devextreme-react";
import * as ReduxOidc from "redux-oidc";
import configuration from "../../configuration";
import { GLOBAL_ROLE_SHORTCUTS_CLAIM_TYPE, parseGlobalShortcutsClaimValue } from "../../common/shortcutsApi";
import { INVENTORY_OPERATIONS, IM_HIDDEN_OPERATIONS_CLAIM, parseHiddenOperationIds } from "../../im/InventoryManagement/inventoryOperations";
import { ModuleNames } from "../../enum/Enum";

/** Stable references — inline objects each render break dxList selectedItem sync and can cause update loops */
const MENU_GENERAL = { id: 'General', text: 'General Settings', icon: 'showpanel' };
const MENU_GLOBAL_SHORTCUTS = { id: 'GlobalShortcuts', text: 'Global Shortcuts', icon: 'showpanel' };

function pathsSignature(paths) {
    if (!paths || paths.length === 0) return '';
    return [...paths].filter(Boolean).map(String).sort().join('\u0001');
}

const ManageSettingsPopUp = (props) => {

    var user = props.oidc.user;
    const userName = user?.profile?.name;
    const addGlobalLayoutSettingKey = 'ADDGLOBALAYOUT';
    const highlightIncomingOrderSettingKey = 'WMHIGHLIGHTINCOMINGORDER';
    const settingKeys = ['LOGINTYPEID', 'RECVSHIPDTACCESS', 'UPDATERECVSHIPDT', 'CREATECONSIGNEE', 'CONSIGNEEPROFILE',
        'QUANTITYCHECK', 'BOLREPORTSTATUS', 'ITEMSEARCHFILTER', 'WMIMPORTFILES', 'WMIMPORTFILESPATH',
        'WMSHIPMENTPROFILE', 'SHOWASSOCIATECUSTOMER', 'WMTRANSDATECONTROL', 'RECEDITDELFROMSTAGE', 'SHIPEDITDELFROMSTAGE', 
        'WMCLEARLOTFILTER', 'WMDETAILDATAGRIDMODE', 'LANDINGPAGE', 'OMDEFAULTPRICELEVEL', 'WMHISTORYSHIPMENTREPORTNAME', 'WMHISTORYSHIPMENTREPORTFORMAT', 
        'WMHISTORYRECEIPTREPORTNAME', 'WMHISTORYRECEIPTREPORTFORMAT', 'DYNAMICFORMSETTING', 'SODADDSEEDLOTWAREHOUSE', 'SODADDSEEDLOTLOCATION', 
        'IMDEFAULTRECEIPTPROFILE','IMDEFAULTUSAGEPROFILE','IMDEFAULTADJUSTMENTPROFILE','IMDEFAULTREASONCODEUNAVAILABLEITEMS', 'REPORTQUERYTIMEOUT', 'USEWEBORDER', 'WMDEFAULTINVENTORYITEMSTAB', 'WMINVENTORYITEMSNETAVAIL', highlightIncomingOrderSettingKey, addGlobalLayoutSettingKey];
   
    const [lstConsigneeProfile, setlstConsigneeProfile] = useState([]);
    const [lstInventoryProfile, setlstInventoryProfile] = useState([]);
    const [lstShipmentProfile, setlstShipmentProfile] = useState([]);
    const [routesLst, setroutesLst] = useState(new DataSource());
    const [wmHistoryShipmentReportFormats, setWMHistoryShipmentReportFormats] = useState([]);
    const [wmHistoryReceiptReportFormats, setWMHistoryReceiptReportFormats] = useState([]);
    const [isWMVisible, setisWMVisible] = useState(false);
    const [isOMVisible, setisOMVisible] = useState(false);
    const [isSODVisible, setisSODVisible] = useState(false);
    const [isIMVisible, setisIMVisible] = useState(false);
    const [modules, setModules] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);

    const [searchedText, setSearcgedText] = useState('');
    const [isLoaded, setisLoaded] = useState(false);
    const [foundCounts, setFoundCounts] = useState(0);
    const [loadIndicatorVisible, setLoadIndicatorVisible] = useState(false);
    const [globalRoleShortcuts, setGlobalRoleShortcuts] = useState([]);
    const [popupState, setPopUpState] = useState(props.visibility);
    const [settingObj, setSettingObj] = useState({
        LOGINTYPEID: 'A',
        RECVSHIPDTACCESS: 'A',
        UPDATERECVSHIPDT: 'Y',
        CREATECONSIGNEE: 'N',
        CONSIGNEEPROFILE: '',
        QUANTITYCHECK: 'N',
        BOLREPORTSTATUS: 'B',
        ITEMSEARCHFILTER: 'A',
        WMIMPORTFILES: 'N',
        WMIMPORTFILESPATH: '',
        WMSHIPMENTPROFILE: '',
        SHOWASSOCIATECUSTOMER: 'N',
        WMTRANSDATECONTROL: 'A',
        RECEDITDELFROMSTAGE: 'R',
        SHIPEDITDELFROMSTAGE: 'R',
        WMCLEARLOTFILTER: 'N',
        WMDETAILDATAGRIDMODE: 'ExpressLotMode',
        LANDINGPAGE: '/home',
        OMDEFAULTPRICELEVEL: '',
        DYNAMICFORMSETTING: 'No',
        WMHISTORYSHIPMENTREPORTNAME: 'WMR0004',
        WMHISTORYSHIPMENTREPORTFORMAT: 'Standard Abecas',
        WMHISTORYRECEIPTREPORTNAME: 'WMR0044',
        WMHISTORYRECEIPTREPORTFORMAT: 'Standard Abecas',
        SODADDSEEDLOTWAREHOUSE: "RSFCI",
        SODADDSEEDLOTLOCATION: "STRT001B",
        IMDEFAULTRECEIPTPROFILE: '',
        IMDEFAULTUSAGEPROFILE: '',
        IMDEFAULTADJUSTMENTPROFILE: '',
        IMDEFAULTREASONCODEUNAVAILABLEITEMS: '',
        REPORTQUERYTIMEOUT: 300,
        USEWEBORDER: 'N',
        WMDEFAULTINVENTORYITEMSTAB: 'Item',
        WMINVENTORYITEMSNETAVAIL: 'N',
        WMHIGHLIGHTINCOMINGORDER: '',
        ADDGLOBALAYOUT: 'N',
        // Comma-separated hidden Inventory operation Ids; empty = all operations visible.
        IMHIDDENOPERATIONS: ''
    });
    var accessToken = props.oidc.user.access_token;
    const YesNoFlags = [{ id: 1, name: 'Yes', value: 'Y' }, { id: 2, name: 'No', value: 'N' }];
    const LoginType = [
        { id: 1, name: 'Login as Customer', value: 'A' },
        { id: 2, name: 'Login as Consignee', value: 'B' },
        { id: 3, name: 'Login as Carrier', value: 'C' },
        { id: 4, name: 'Login as ABECAS User', value: 'D' },
    ];
    const OMDefaultPriceLevel = [
        { id: 0, name:null, value: null },
        { id: 1, name: 'Price Level A', value: 'A' },
        { id: 2, name: 'Price Level B', value: 'B' },
        { id: 3, name: 'Price Level C', value: 'C' },
        { id: 4, name: 'Price Level D', value: 'D' },
        { id: 5, name: 'Price Level E', value: 'E' },
        { id: 6, name: 'Price Level F', value: 'F' },
        { id: 7, name: 'Auto calculate', value: 'G' }
    ];
    const DYNAMICFORMSETTING = [
        { id: 1, name: 'Yes', value: 'Yes' },
        { id: 2, name: 'No', value: 'No' }
    ];
    const RecShipDateAccess = [{ id: 1, name: 'Full Access', value: 'A' }, { id: 2, name: 'Visible Not Accessible', value: 'B' },
    { id: 3, name: 'Hidden', value: 'C' }, { id: 4, name: 'Hidden and Empty', value: 'D' }];
    const BolReportStatus = [{ id: 1, name: 'Uncommitted only', value: 'A' }, { id: 2, name: 'Yes, Committed and Uncommitted', value: 'B' },
    { id: 3, name: 'Committed only', value: 'C' }];
    const ItemSearchFilter = [{ id: 1, name: 'Show All', value: 'A' }, { id: 2, name: 'With Net Available Qty', value: 'B' },
    { id: 3, name: 'With Available Qty', value: 'C' }, { id: 4, name: 'Win On Hand Qty', value: 'D' }];
    const QtyChk = [{ id: 1, name: 'No, donot check', value: 'N' }, { id: 2, name: 'Yes, check for shipments', value: 'Y' }]
    const TransDateCtrl = [{ id: 1, name: 'Allow all dates', value: 'A' }, { id: 2, name: 'Allow only future dates', value: 'B' }];
    const EditDelFromStages = [{ id: 1, name: 'From Plan Stage', value: 'P' }, { id: 2, name: 'From Future Stage', value: 'F' }, { id: 3, name: 'From Pending Stage', value: 'N' }, { id: 4, name: 'From Ready To Receive/Pick Stage', value: 'R' }];
    const DetailDataGridModes = [{ id: 1, name: 'Express Item Mode', value: 'ExpressItemMode' }, { id: 2, name: 'Express Lot Mode', value: 'ExpressLotMode' }, { id: 3, name: 'Item Mode', value: 'ItemMode' }];
    const WMHistoyShipmentReports = [{ id: 1, name: 'Bill Of Lading Report', value: 'WMR0004' }, { id: 2, name: 'Historical Rec/Ship Report', value: 'WMR0044' }];
    const WMHistoyReceiptReports = [{ id: 1, name: 'Historical Rec/Ship Report', value: 'WMR0044' }, { id: 2, name: 'Receipts Put Away', value: 'WMR0008' }];
    const DefaultInventoryItemsTab = [{ id: 1, name: 'Item', value: 'Item' }, { id: 2, name: 'Lot', value: 'Lot' }, { id: 3, name: 'Sublot', value: 'Sublot' }];
    const HighlightIncomingOrder = [{ id: 1, name: 'None', value: '' }, { id: 2, name: 'Yellow', value: 'Yellow' }, { id: 3, name: 'Green', value: 'Green' }];
    const controlsRef = useRef({});
    const hideInfo = () => {
        setPopUpState(false);
        props.parentCallback(false);
    };
    useEffect(() => {
        if (searchedText !== '')
            highlightMatchedControls();
    }, [searchedText]);
    useEffect(() => {
        setSearcgedText('');
        setSelectedItem(MENU_GENERAL);
    }, [props.popupOpen]);

    const highlightMatchedControls = () => {
        if (searchedText === '')
            return;
        let founded = 0;
        Object.values(controlsRef.current).forEach((control) => {
            if (control) {
                const instance = control.instance;
                if (instance) {
                    let datasource = control.props?.dataSource
                        ? control.props.dataSource.filter(i => i?.name?.toString().toLowerCase().includes(searchedText.toLowerCase()))
                        : [];

                    let items = control.props?.items
                        ? control.props.items.filter(i => i?.name?.toString().toLowerCase().includes(searchedText.toLowerCase()))
                        : [];

                    let label = control.props?.label || "";
                    let element = control.instance?.element();
                    let value = instance.option("value") || instance.option("text") || "";
                    if (element) {
                        if (label && label.toString().toLowerCase().includes(searchedText.toLowerCase()) || (datasource && datasource.length > 0) || (items && items.length > 0) || value.toLowerCase().includes(searchedText.toLowerCase())) {
                            element.style.border = "2px solid yellow"; // Highlight match
                            founded = founded + 1;
                        } else {
                            element.style.border = ""; // Remove highlight
                        }
                    }
                }
            }
        });
        setFoundCounts(founded);
    };

    useEffect(() => {
        if (searchedText === '') {
            document.querySelectorAll(".dx-selectbox, .dx-textbox, .dx-datebox").forEach((el) => {
                el.style.border = ""; // Change color as needed
            });
        }

    }, [selectedItem, searchedText]);
    useEffect(() => {
        setLoadIndicatorVisible(true);
        Promise.all([
            axios
                .get(`${window._env_.REACT_APP_APIS}/${apiRoutes.WMWebLookup.GetConsigneeProfiles}`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            access_token: accessToken,
                            Authorization: `Bearer ${accessToken}`,
                        },
                    })
                .then((res) => {
                    setlstConsigneeProfile(res.data);
                }),
            axios
            .get(`${window._env_.REACT_APP_APIS}/${apiRoutes.IM.GetProfiles}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                })
            .then((res) => {
                setlstInventoryProfile(res.data);
            }),
            axios
                .get(`${window._env_.REACT_APP_APIS}/${apiRoutes.WMWebLookup.GetShipmentProfiles}`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            access_token: accessToken,
                            Authorization: `Bearer ${accessToken}`,
                        },
                    })
                .then((res) => {
                    setlstShipmentProfile(res.data);
                }),
            axios
            .get(
                `${window._env_.REACT_APP_AUTH_URL}/${apiRoutes.idp.GetModules}?username=${encodeURIComponent(userName)}`,
                {
                  headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                  },
                }
              )
                .then((res) => {
                    if (res.status === 200) {
                        if (res.data) {
                            let modulesArr = res.data.split(',');
                            setisWMVisible(modulesArr.includes(WM));
                            setisOMVisible(modulesArr.includes(OM));
                            setisSODVisible(modulesArr.includes(SO));
                            setisIMVisible(modulesArr.includes(IM));
                            const menuItems = modulesArr
                                .filter(module => SettingModules.includes(module)).sort()
                                .map(module => ({
                                    id: module,
                                    text: ModuleNames[module] || module,
                                    icon: "showpanel",
                                }));

                            menuItems.unshift(MENU_GENERAL);
                            menuItems.splice(1, 0, MENU_GLOBAL_SHORTCUTS);
                            setModules(menuItems);
                            const ungroupedRoutesFiltered = ungroupedRoutesData;
                            setroutesLst(new DataSource({
                                store: {
                                    type: 'array',
                                    data: ungroupedRoutesFiltered,
                                    key: 'value',
                                },
                                group: 'key',
                            }));
                        }
                    }
                })
        ]).then(() => {
            loadSettings();
        }).catch(() => {
            setLoadIndicatorVisible(false);
            notify({
                message: 'Couldnt Load Data!!',
                width: 450,
            }, 'error', 2000);
        });
    }, []);
    const loadSettings = () => {
        axios
            .get(`${window._env_.REACT_APP_AUTH_URL}/${apiRoutes.idp.GetRoleSetting}?roleName=${props.roleName}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                })
            .then((res) => {
                if (res.data && res.data.successflag) {
                    var wmHistoryShipmentReportName = settingObj.WMHISTORYSHIPMENTREPORTNAME;
                    var wmHistoryReceiptReportName = settingObj.WMHISTORYRECEIPTREPORTNAME;
                    res.data.lstRoleClaims.forEach(function (arrayItem) {
                        
                        var claimValue = arrayItem.claimvalue;
                        if (arrayItem.claimtype == settingKeys[30] && claimValue && claimValue != '') {
                             claimValue = parseInt(claimValue);
                        }

                        setSettingObj(prvState => ({
                            ...prvState,
                            [arrayItem.claimtype]: claimValue
                        }));

                        if (arrayItem.claimtype == settingKeys[19]) {
                            wmHistoryShipmentReportName = arrayItem.claimvalue;
                        }

                        if (arrayItem.claimtype == settingKeys[21]) {
                            wmHistoryReceiptReportName = arrayItem.claimvalue;
                        }
                    });

                    const shortcutEntry = (res.data.lstRoleClaims || []).find(
                        (c) => String(c.claimtype || c.ClaimType || "").toLowerCase() === GLOBAL_ROLE_SHORTCUTS_CLAIM_TYPE,
                    );
                    if (shortcutEntry) {
                        const raw = shortcutEntry.claimvalue ?? shortcutEntry.ClaimValue;
                        const list = parseGlobalShortcutsClaimValue(raw);
                        setGlobalRoleShortcuts(
                            list.map((item, idx) => ({
                                id: item.id || item.Id || `gsc_${idx}`,
                                text: item.text || item.Text,
                                path: item.path || item.Path,
                                icon: item.icon || item.Icon || "fa fa-link",
                            })),
                        );
                    } else {
                        setGlobalRoleShortcuts([]);
                    }

                    axios.get(`${window._env_.REACT_APP_APIS}/${apiRoutes.reports.GetReportFormatsAllFacilities}?reportName=${wmHistoryShipmentReportName}`,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                access_token: accessToken,
                                Authorization: `Bearer ${accessToken}`,
                            }
                        })
                        .then((res) => {
                            setWMHistoryShipmentReportFormats(res.data);
                            axios.get(`${window._env_.REACT_APP_APIS}/${apiRoutes.reports.GetReportFormatsAllFacilities}?reportName=${wmHistoryReceiptReportName}`,
                                {
                                    headers: {
                                        "Content-Type": "application/json",
                                        access_token: accessToken,
                                        Authorization: `Bearer ${accessToken}`,
                                    }
                                })
                                .then((res) => {
                                    setWMHistoryReceiptReportFormats(res.data);
                                    setisLoaded(true);
                                    setLoadIndicatorVisible(false);
                                })
                                .catch((err) => {
                                    setisLoaded(true);
                                    setLoadIndicatorVisible(false);
                                    console.log(err, "Error getting report format data");
                                });
                        })
                        .catch((err) => {
                            setisLoaded(true);
                            setLoadIndicatorVisible(false);
                            console.log(err, "Error getting report format data");
                        });
                }
            }).catch((err) => {
                setLoadIndicatorVisible(false);
                setisLoaded(true);
            });
    };
    const SaveRoleSetting = (e,Claimtype, Claimvalue) => {
        if (!e.event) return; 
        if (Claimtype == 'WMHISTORYSHIPMENTREPORTFORMAT' || Claimtype == 'WMHISTORYRECEIPTREPORTFORMAT') {
            if (Claimvalue == 'Default')
                Claimvalue = '';
        }

        setSettingObj(prvState => ({
            ...prvState,
            [Claimtype]: Claimvalue
        }));
        setLoadIndicatorVisible(true);

        var claimValue = Claimvalue;
        if (Claimtype == settingKeys[30]) {
          claimValue = Claimvalue.toString();
        }

        var obj = {
            claimtype: Claimtype,
            roleName: props.roleName,
            claimvalue: claimValue,
        }
        axios.post(`${window._env_.REACT_APP_AUTH_URL}/${apiRoutes.idp.SaveRoleSetting}`, obj,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            })
            .then((res) => {
                if (res.data && res.data.successflag) {
                    notify({
                        message: 'Record Saved!',
                        width: 100,
                    }, 'success', 2000);
                }
                else {
                    notify({
                        message: 'Couldnt Save Data!!',
                        width: 450,
                    }, 'error', 2000);
                }
                setLoadIndicatorVisible(false);
            }).catch((err) => {
                notify({
                    message: 'Couldnt Save Data!!',
                    width: 450,
                }, 'error', 2000);
                setLoadIndicatorVisible(false);
            });
    };

    // Toggle an Inventory operation's visibility for this role. The hidden Ids are stored as
    // a single comma-separated role claim (IMHIDDENOPERATIONS); ON = visible, OFF = hidden.
    const onOperationVisibilityChanged = (e, operationId) => {
        if (!e.event) return;
        const hidden = new Set(parseHiddenOperationIds(settingObj[IM_HIDDEN_OPERATIONS_CLAIM]));
        if (e.value) hidden.delete(operationId); else hidden.add(operationId);
        SaveRoleSetting(e, IM_HIDDEN_OPERATIONS_CLAIM, Array.from(hidden).join(','));
    };

    const SaveWMHistoryReportNameSetting = (Claimtype, Claimvalue, formatClaimtype) => {
        if (!isLoaded)
            return;

        setSettingObj(prvState => ({
            ...prvState,
            [Claimtype]: Claimvalue
        }));

        setLoadIndicatorVisible(true);

        var obj = {
            claimtype: Claimtype,
            roleName: props.roleName,
            claimvalue: Claimvalue,
        }

        axios.post(`${window._env_.REACT_APP_AUTH_URL}/${apiRoutes.idp.SaveRoleSetting}`, obj,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            })
            .then((res) => {
                if (res.data && res.data.successflag) {
                    setSettingObj(prvState => ({
                        ...prvState,
                        [formatClaimtype]: ''
                    }));

                    obj = {
                        claimtype: formatClaimtype,
                        roleName: props.roleName,
                        claimvalue: '',
                    }

                    axios.post(`${window._env_.REACT_APP_AUTH_URL}/${apiRoutes.idp.SaveRoleSetting}`, obj,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                access_token: accessToken,
                                Authorization: `Bearer ${accessToken}`,
                            },
                        })
                        .then((res) => {
                            if (res.data && res.data.successflag) {

                                notify({
                                    message: 'Record Saved!',
                                    width: 100,
                                }, 'success', 2000);

                                axios.get(`${window._env_.REACT_APP_APIS}/${apiRoutes.reports.GetReportFormatsAllFacilities}?reportName=${Claimvalue}`,
                                    {
                                        headers: {
                                            "Content-Type": "application/json",
                                            access_token: accessToken,
                                            Authorization: `Bearer ${accessToken}`,
                                        }
                                    })
                                    .then((res) => {
                                        if (formatClaimtype == settingKeys[20]) {
                                            setWMHistoryShipmentReportFormats(res.data);
                                        }
                                        else {
                                            setWMHistoryReceiptReportFormats(res.data);
                                        }

                                        setLoadIndicatorVisible(false);
                                    })
                                    .catch((err) => {
                                        setLoadIndicatorVisible(false);
                                        console.log(err, "Error getting report format data");
                                    });
                            }
                            else {
                                notify({
                                    message: 'Couldnt Save Data!!',
                                    width: 450,
                                }, 'error', 2000);

                                setLoadIndicatorVisible(false);
                            }
                        }).catch((err) => {
                            notify({
                                message: 'Couldnt Save Data!!',
                                width: 450,
                            }, 'error', 2000);
                            setLoadIndicatorVisible(false);
                        });
                }
                else {
                    notify({
                        message: 'Couldnt Save Data!!',
                        width: 450,
                    }, 'error', 2000);
                    setLoadIndicatorVisible(false);
                }


            }).catch((err) => {
                notify({
                    message: 'Couldnt Save Data!!',
                    width: 450,
                }, 'error', 2000);
                setLoadIndicatorVisible(false);
            });
    };

    const saveGlobalRoleShortcuts = () => {
        if (!props.roleName) return;
        SaveRoleSetting({ event: true }, GLOBAL_ROLE_SHORTCUTS_CLAIM_TYPE, JSON.stringify(globalRoleShortcuts));
    };

    function renderSettings(id) {
        return <>
            <div style={{ display: id === 'GlobalShortcuts' || searchedText !== '' ? 'block' : 'none' }}>
                <p className="group-title">
                    <b>Global Shortcuts</b>
                </p>
                <p style={{ fontSize: '12px', color: '#666', maxWidth: '820px', marginBottom: '12px' }}>
                    Choose pages that appear as <b>organization-wide</b> shortcuts on the home page for users whose role is{' '}
                    <b>{props.roleName}</b>, when global shortcuts are enabled in Application Settings. Personal shortcuts are unchanged.
                </p>
                <div className="row settingsRow">
                    <div className="col-md-10">
                        <TagBox
                            ref={(el) => (controlsRef.current['Global Shortcuts pages'] = el)}
                            stylingMode="outlined"
                            labelMode="static"
                            label="Pages for this role"
                            dataSource={ungroupedRoutesData}
                            value={globalRoleShortcuts.map((s) => s.path).filter(Boolean)}
                            valueExpr="value"
                            displayExpr={(item) =>
                                item ? `${item.key || ''} → ${item.name || item.value}` : ''
                            }
                            searchEnabled
                            showSelectionControls
                            multiline
                            maxDisplayedTags={8}
                            onValueChanged={(e) => {
                                const paths = e.value || [];
                                setGlobalRoleShortcuts((prev) => {
                                    const next = paths.map((path, idx) => {
                                        const route = ungroupedRoutesData.find((r) => r.value === path);
                                        const text = route
                                            ? route.name && route.name.includes('->')
                                                ? route.name.split('->').pop().trim()
                                                : route.name
                                            : path;
                                        return {
                                            id: `gsc_${path}_${idx}`,
                                            text: text || path,
                                            path,
                                            icon: 'fa fa-link',
                                        };
                                    });
                                    if (pathsSignature(prev.map((s) => s.path)) === pathsSignature(paths)) {
                                        return prev;
                                    }
                                    return next;
                                });
                            }}
                        />
                    </div>
                    <div className="col-md-2" style={{ paddingTop: '28px' }}>
                        <Button text="Save" type="default" width="100%" onClick={saveGlobalRoleShortcuts} />
                    </div>
                </div>
            </div>
            <div style={{ display: id === 'General' || searchedText !== '' ? "block" : "none" }}>
                <p className='group-title'><b>General Settings</b></p>
                <div className="row">
                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["Login Type ID"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="Login Type ID" placeholder="Select Login Type ID"
                            displayExpr="name"
                            valueExpr="value"
                            dataSource={LoginType}
                            value={settingObj.LOGINTYPEID}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[0], e.value)}
                        />
                    </div>
                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["Landing Page"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="Landing Page" placeholder="Select Landing Page"
                            displayExpr="name"
                            valueExpr="value"
                            grouped={true}
                            dataSource={routesLst}
                            value={settingObj.LANDINGPAGE}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[17], e.value)} />
                    </div>

                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["Allow to change/rearrange controls on forms"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="Allow to change/rearrange controls on forms" placeholder="Allow to change/rearrange controls on forms"
                            displayExpr="name"
                            valueExpr="value"
                            items={DYNAMICFORMSETTING}
                            value={settingObj.DYNAMICFORMSETTING}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[23], e.value)}
                        />
                    </div>
                </div>
                <div className="row settingsRow">
                    <div className="col-md-4">
                        <NumberBox
                            ref={(el) => (controlsRef.current["Report Query Timeout"] = el)}
                            stylingMode="outlined"
                            labelMode="static" 
                            label="Report Query Timeout (seconds)" 
                            placeholder="Report Query Timeout"
                            showSpinButtons={true}
                            max={1000}
                            min={1}
                            format="#"
                            value={settingObj.REPORTQUERYTIMEOUT}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[30], e.value)}
                        />
                    </div>
                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["Add Global Layout"] = el)}
                            stylingMode="outlined"
                            labelMode="static"
                            label="Add Global Layout"
                            placeholder="Add Global Layout"
                            displayExpr="name"
                            valueExpr="value"
                            items={YesNoFlags}
                            value={settingObj.ADDGLOBALAYOUT}
                            onValueChanged={(e) => SaveRoleSetting(e, addGlobalLayoutSettingKey, e.value)}
                        />
                    </div>
                </div>
            </div>
            <div style={{ display: id === 'IM' && isIMVisible || searchedText !== '' ? "block" : "none" }}>
                <p className='group-title'><b>Default Profiles</b></p>
                <div className="row">
                <div className="col-md-4">
                       <SelectBox
                            ref={(el) => (controlsRef.current["Receipt Profile"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="Receipt Profile" placeholder="Select Receipt Profile"
                            displayExpr="name"
                            valueExpr="name"
                            dataSource={lstInventoryProfile}
                            value={settingObj.IMDEFAULTRECEIPTPROFILE}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[26], e.value)}
                        />
                    </div>
                    <div className="col-md-4">
                       <SelectBox
                            ref={(el) => (controlsRef.current["Usage Profile"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="Usage Profile" placeholder="Select Usage Profile"
                            displayExpr="name"
                            valueExpr="name"
                            dataSource={lstInventoryProfile}
                            value={settingObj.IMDEFAULTUSAGEPROFILE}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[27], e.value)}
                        />
                    </div>
                    <div className="col-md-4">
                       <SelectBox
                            ref={(el) => (controlsRef.current["Adjustment Profile"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="Adjustment Profile" placeholder="Select Adjustment Profile"
                            displayExpr="name"
                            valueExpr="name"
                            dataSource={lstInventoryProfile}
                            value={settingObj.IMDEFAULTADJUSTMENTPROFILE}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[28], e.value)}
                        />
                    </div>
                </div>
                <div />
            </div>
            <div style={{ display: id === 'IM' && isIMVisible || searchedText !== '' ? "block" : "none" }}>
                <p className='group-title'><b>Default Reason Code</b></p>
                <div className="row">
                    <div className="col-md-4">
                        <TextBox
                            ref={(el) => (controlsRef.current["Default Reason Code for unavailable items"] = el)}
                            className="input-field"
                            stylingMode="outlined"
                            labelMode="static" label="Default Reason Code for unavailable items" placeholder="Enter Reason Code"
                            name="importpath"
                            value={settingObj.IMDEFAULTREASONCODEUNAVAILABLEITEMS}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[29], e.value)}
                        />
                    </div>
                </div>
                <div />
            </div>
            <div style={{ display: id === 'IM' && isIMVisible || searchedText !== '' ? "block" : "none" }}>
                <p className='group-title'><b>Operation Visibility</b></p>
                <p style={{ marginTop: '-6px', marginBottom: '10px', fontSize: '12px', color: '#888' }}>
                    Turn an operation off to hide it from the Operation dropdown on the Inventory Operation screen.
                </p>
                <div className="row">
                    {INVENTORY_OPERATIONS.map((op) => (
                        <div className="col-md-4" key={op.Id} style={{ marginBottom: '12px', display: 'flex', alignItems: 'center' }}>
                            <Switch
                                ref={(el) => (controlsRef.current["Operation - " + op.Name] = el)}
                                value={!parseHiddenOperationIds(settingObj[IM_HIDDEN_OPERATIONS_CLAIM]).includes(op.Id)}
                                onValueChanged={(e) => onOperationVisibilityChanged(e, op.Id)}
                            />
                            <span style={{ marginLeft: '10px' }}>{op.Name}</span>
                        </div>
                    ))}
                </div>
                <div />
            </div>
            <div style={{ display: id === 'OM' && isOMVisible || searchedText !== '' ? "block" : "none" }}>
                <p className='group-title'><b>OM Settings</b></p>
                <div className="row">
                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["OM Default Price Level to Display"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="OM Default Price Level to Display" placeholder="Select Price Level"
                            displayExpr="name"
                            valueExpr="value"
                            items={OMDefaultPriceLevel}
                            value={settingObj.OMDEFAULTPRICELEVEL}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[18], e.value)}
                            showClearButton={true} 
                        />
                    </div>
                </div>
                <div />
            </div>

            <div style={{ display: id === 'SO' && isSODVisible || searchedText !== '' ? "block" : "none" }}>
                <p className='group-title'><b>SOD Settings</b></p>
                <div className="row">
                    <div className="col-md-4">
                        <TextBox
                            ref={(el) => (controlsRef.current["Add Seed Lot Warehouse"] = el)}
                            className="input-field"
                            stylingMode="outlined"
                            labelMode="static" label="Add Seed Lot Warehouse" placeholder="Enter Add Seed Lot Warehouse"
                            name="importpath"
                            value={settingObj.SODADDSEEDLOTWAREHOUSE}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[24], e.value)}
                        />
                    </div>
                    <div className="col-md-4">
                        <TextBox
                            ref={(el) => (controlsRef.current["Add Seed Lot Location"] = el)}
                            className="input-field"
                            stylingMode="outlined"
                            labelMode="static" label="Add Seed Lot Location" placeholder="Enter Add Seed Lot Location"
                            name="importpath"
                            value={settingObj.SODADDSEEDLOTLOCATION}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[25], e.value)}
                        />
                    </div>
                </div>
                <div />
            </div>

            <div style={{ display: id === 'WM' && isWMVisible || searchedText !== '' ? "block" : "none" }}>
                <p className='group-title'><b>WM Settings</b></p>
                <div className="row">
                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["Receive/Ship Date Access"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="Receive/Ship Date Access" placeholder="Receive/Ship Date Access"
                            displayExpr="name"
                            valueExpr="value"
                            items={RecShipDateAccess}
                            value={settingObj.RECVSHIPDTACCESS}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[1], e.value)}
                        />
                    </div>
                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["Update Receive/Ship Date"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="Update Receive/Ship Date" placeholder="Select Update Receive/Ship Date"
                            displayExpr="name"
                            valueExpr="value"
                            items={YesNoFlags}
                            value={settingObj.UPDATERECVSHIPDT}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[2], e.value)}
                        />
                    </div>
                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["Create Consignee"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="Create Consignee" placeholder="Select Create Consignee"
                            displayExpr="name"
                            valueExpr="value"
                            items={YesNoFlags}
                            value={settingObj.CREATECONSIGNEE}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[3], e.value)}
                        />
                    </div>
                </div>
                <div className="row settingsRow">
                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["Consignee Profile"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="Consignee Profile" placeholder="Select Consignee Profile"
                            displayExpr="name"
                            valueExpr="name"
                            dataSource={lstConsigneeProfile}
                            value={settingObj.CONSIGNEEPROFILE}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[4], e.value)}
                        />
                    </div>
                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["Quantity Check"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="Quantity Check" placeholder="Select Quantity Check"
                            displayExpr="name"
                            valueExpr="value"
                            items={QtyChk}
                            value={settingObj.QUANTITYCHECK}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[5], e.value)}
                        />
                    </div>
                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["Details Grid Default Data Entry Mode"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="Details Grid Default Data Entry Mode" placeholder="Details Grid Default Data Entry Mode"
                            displayExpr="name"
                            valueExpr="value"
                            items={DetailDataGridModes}
                            value={settingObj.WMDETAILDATAGRIDMODE}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[16], e.value)}
                        />
                    </div>
                </div>
                <div className="row settingsRow">
                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["BOL Status"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="BOL Status" placeholder="Select BOL Status"
                            displayExpr="name"
                            valueExpr="value"
                            items={BolReportStatus}
                            value={settingObj.BOLREPORTSTATUS}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[6], e.value)}
                        />
                    </div>

                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["Item Filter"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="Item Filter" placeholder="Select Item Filter"
                            displayExpr="name"
                            valueExpr="value"
                            items={ItemSearchFilter}
                            value={settingObj.ITEMSEARCHFILTER}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[7], e.value)}
                        />
                    </div>
                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["Import Data"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="Import Data" placeholder="Select Import Data"
                            displayExpr="name"
                            valueExpr="value"
                            items={YesNoFlags}
                            value={settingObj.WMIMPORTFILES}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[8], e.value)}
                        />
                    </div>
                </div>
                <div className="row settingsRow">
                    <div className="col-md-4">
                        <TextBox
                            ref={(el) => (controlsRef.current["Import Path"] = el)}
                            className="input-field"
                            stylingMode="outlined"
                            labelMode="static" label="Import Path" placeholder="Enter Import Path"
                            name="importpath"
                            value={settingObj.WMIMPORTFILESPATH}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[9], e.value)}
                        />
                    </div>
                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["Shipment Profile"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="Shipment Profile" placeholder="Select Shipment Profile"
                            displayExpr="name"
                            valueExpr="name"
                            dataSource={lstShipmentProfile}
                            value={settingObj.WMSHIPMENTPROFILE}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[10], e.value)}
                        />
                    </div>
                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["History Shipment Report"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="History Shipment Report" placeholder="History Shipment Report"
                            displayExpr="name"
                            valueExpr="value"
                            items={WMHistoyShipmentReports}
                            value={settingObj.WMHISTORYSHIPMENTREPORTNAME}
                            onValueChanged={(e) => SaveWMHistoryReportNameSetting(settingKeys[19], e.value, settingKeys[20])}
                        />
                    </div>
                </div>
                <div className="row settingsRow">
                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["History Shipment Report Format"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="History Shipment Report Format" placeholder="Select a Format"
                            dataSource={wmHistoryShipmentReportFormats}
                            value={settingObj.WMHISTORYSHIPMENTREPORTFORMAT ? settingObj.WMHISTORYSHIPMENTREPORTFORMAT : "Default"}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[20], e.value)}
                            defaultValue="Standard Abecas"
                        />
                    </div>
                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["Associate Customer Information"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="Associate Customer Information" placeholder="Select Associate Customer Information"
                            displayExpr="name"
                            valueExpr="value"
                            items={YesNoFlags}
                            value={settingObj.SHOWASSOCIATECUSTOMER}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[11], e.value)}
                        />
                    </div>
                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["Transaction Date Control"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="Transaction Date Control" placeholder="Select Transaction Date Control"
                            displayExpr="name"
                            valueExpr="value"
                            items={TransDateCtrl}
                            value={settingObj.WMTRANSDATECONTROL}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[12], e.value)}
                        />
                    </div>
                </div>
                <div className="row settingsRow">
                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["Clear Lot Filter (Create Trans)"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="Clear Lot Filter (Create Trans)" placeholder="Clear Lot Filter (Create Trans)"
                            displayExpr="name"
                            valueExpr="value"
                            items={YesNoFlags}
                            value={settingObj.WMCLEARLOTFILTER}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[15], e.value)}
                        />
                    </div>
                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["Donot Allow to Delete/Edit Receipts"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="Donot Allow to Delete/Edit Receipts" placeholder="Select From Stage"
                            displayExpr="name"
                            valueExpr="value"
                            items={EditDelFromStages}
                            value={settingObj.RECEDITDELFROMSTAGE}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[13], e.value)}
                        />
                    </div>
                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["Donot Allow to Delete/Edit Shipments"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="Donot Allow to Delete/Edit Shipments" placeholder="Select From Stage"
                            displayExpr="name"
                            valueExpr="value"
                            items={EditDelFromStages}
                            value={settingObj.SHIPEDITDELFROMSTAGE}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[14], e.value)}
                        />
                    </div>
                </div>
                <div className="row settingsRow">
                    <div className="col-md-4">

                        <SelectBox
                            ref={(el) => (controlsRef.current["History Receipt Report"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="History Receipt Report" placeholder="History Receipt Report"
                            displayExpr="name"
                            valueExpr="value"
                            items={WMHistoyReceiptReports}
                            value={settingObj.WMHISTORYRECEIPTREPORTNAME}
                            onValueChanged={(e) => SaveWMHistoryReportNameSetting(settingKeys[21], e.value, settingKeys[22])}
                        />
                    </div>
                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["History Receipt Report Format"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="History Receipt Report Format" placeholder="Select a Format"
                            dataSource={wmHistoryReceiptReportFormats}
                            value={settingObj.WMHISTORYRECEIPTREPORTFORMAT ? settingObj.WMHISTORYRECEIPTREPORTFORMAT : "Default"}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[22], e.value)}
                            defaultValue="Standard Abecas"
                        />
                    </div>
                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["Use Web Order"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="Use Web Order" placeholder="Select Use Web Order"
                            displayExpr="name"
                            valueExpr="value"
                            items={YesNoFlags}
                            value={settingObj.USEWEBORDER}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[31], e.value)}
                        />
                    </div>
                </div>
                <div className="row settingsRow">
                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["Default Inventory Items Tab"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="Default Inventory Items Tab" placeholder="Select Default Inventory Items Tab"
                            displayExpr="name"
                            valueExpr="value"
                            items={DefaultInventoryItemsTab}
                            value={settingObj.WMDEFAULTINVENTORYITEMSTAB}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[32], e.value)}
                        />
                    </div>
                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["Inventory Items .Net Avail > 0"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="Inventory Items .Net Avail > 0" placeholder="Select Inventory Items .Net Avail > 0"
                            displayExpr="name"
                            valueExpr="value"
                            items={YesNoFlags}
                            value={settingObj.WMINVENTORYITEMSNETAVAIL}
                            onValueChanged={(e) => SaveRoleSetting(e,settingKeys[33], e.value)}
                        />
                    </div>
                    <div className="col-md-4">
                        <SelectBox
                            ref={(el) => (controlsRef.current["Highlight Incoming Order"] = el)}
                            stylingMode="outlined"
                            labelMode="static" label="Highlight Incoming Order" placeholder="Select Highlight Color"
                            displayExpr="name"
                            valueExpr="value"
                            items={HighlightIncomingOrder}
                            value={settingObj.WMHIGHLIGHTINCOMINGORDER}
                            onValueChanged={(e) => SaveRoleSetting(e,highlightIncomingOrderSettingKey, e.value)}
                        />
                    </div>
                </div>
                <div />
            </div>
        </>
    }

    return (
        <Popup
            visible={popupState}
            onHiding={hideInfo}
            dragEnabled={false}
            hideOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            title={`Manage Settings for ${props.roleName}`}
            container="#root"
            width="100vw"
            height="100vh"
        >
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                visible={loadIndicatorVisible}
                showIndicator={true}
                shading={true}
                showPane={true}
                hideOnOutsideClick={false}
            />
            <ScrollView width="100%" height="100%">
                <div className="row" id="role-setting-popup"style={{ height: '100%' }}>
                    <div className='col-md-2'style={{ height: '100%' }}>
                        <Drawer
                            opened={true}
                            closeOnOutsideClick={false}
                            openedStateMode="shrink"
                            position="left"
                            revealMode="expand"
                            shading={false}
                        >
                            <List
                                items={modules}
                                selectedItem={selectedItem}
                                selectionMode="single"
                                keyExpr="id"
                                displayExpr="text"
                                onItemClick={(e) => {
                                    if (e.itemData) {
                                        setSearcgedText('');
                                        setSelectedItem(e.itemData);
                                    }
                                }}
                            />
                        </Drawer>
                    </div>
                    <div className='col-md-9'>
                        <div className='col-md-12 search-box'>
                            <TextBox
                                stylingMode="outlined"
                                labelMode="static" label="" placeholder="Search..."
                                width={450}
                                value={searchedText}
                                onInput={(e) => setSearcgedText(e.event.target.value.toString())}
                            >
                                <i className="dx-icon dx-icon-search" style={{ color: "var(--dx-button-normal-bg)", position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)" }}></i>
                            </TextBox>
                        </div>
                        {searchedText && searchedText !== '' && searchedText !== null && <div className='col-md-3'> <p className='group-title'>Found Result: <b> {foundCounts}</b></p></div>}
                        <div className='settings-card' style={{ marginTop: '15px' }}>
                            {selectedItem && renderSettings(selectedItem.id)}
                        </div>
                    </div>
                </div>

            </ScrollView>
        </Popup>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(ManageSettingsPopUp);